import { defineType } from "sanity";
import videoWithPosterImage from "../videoWithPosterImage";
import { multilingualStringPreview } from "../../base/multilingualArrayString";

export default defineType({
  name: "videoCTA",
  type: "object",
  title: "Video CTA",
  fields: [
    {
      name: "label",
      type: "multilingualArrayString",
      description: 'leave empty for "View Video"'
    },
    {
      name: "video",
      title: "Video",
      type: videoWithPosterImage.name,
      validation: (Rule) => Rule.required()
    },
    {
      name: "type",
      type: "buttonType"
    }
  ],
  preview: {
    select: {
      title: "label"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "View Video"
      };
    }
  }
});
